import request from '@/utils/request'
import interfaceHandle from '@/utils/index'
export function adminlogin(data) {
  return request({
    url: '',
    method: 'post',
    data: interfaceHandle('adminlogin', data)
  })
}

export function login(data) {
  return request({
    url: '',
    method: 'post',
    data: interfaceHandle('userlogin', data)
  })
}
export function querydictionarydata(data) {
  return request({
    url: '',
    method: 'post',
    data: interfaceHandle('querydictionarydata', data, true)
  })
}
export function wechatuserlogin(data) {
  return request({
    url: '',
    method: 'post',
    data: interfaceHandle('wechatuserlogin', data)
  })
}
export function userauth(data) {
  return request({
    url: '',
    method: 'post',
    data: interfaceHandle('userauth', data, true)
  })
}

export function bindmobilephone(data) {
  return request({
    url: '',
    method: 'post',
    data: interfaceHandle('bindmobilephone', data, true)
  })
}
export function getsmscode(data) {
  return request({
    url: '',
    method: 'post',
    data: interfaceHandle('getsmscode', data,true)
  })
}


// WEBPACK FOOTER //
// ./src/api/login.js